import React from "react";
import UDigLogo from "../images/circle-logo.png";
import { WelcomeText } from "../Text";
import WelcomeForm from "../components/forms/WelcomeForm";

const WelcomeScreen: React.FC = () => {
  return (
    <>
      <a href="https://www.udig.com/">
        <img
          className="absolute top-6 left-6 w-10 h-10 tablet:w-16 tablet:h-16 laptop:w-20 laptop:h-20 laptop:top-10 laptop:left-10"
          src={UDigLogo}
          alt={WelcomeText.logoAltText}
        />
      </a>

      <div className="flex justify-center">
        <div className="text-UDig-gray font-sans mt-20 mx-10 flex flex-col items-center tablet:w-3/5 tablet:mx-16 laptop:mt-20 laptop:w-2/5">
          <h1 className="font-bold text-5xl uppercase text-center">
            {WelcomeText.title}
          </h1>
          <h3 className="mt-2 text-center text-sub-title">
            {WelcomeText.subTitle}
          </h3>
          <WelcomeForm />
        </div>
      </div>
    </>
  );
};

export default WelcomeScreen;
